// import {
//   defaultGridLayout,
//   createGridItem,
// } from '../../../store/global/gridlayout';

// import { documentState } from './documents/state';
// import { travelDetailsState } from './travel-details/state';
// import { localDetailsState } from './local-details/state';

import { bookingsState } from "./bookings/state";
import { bookingPromotersState } from "./promoters/state";
import { bookingReportsStates } from "./reports/state";
import { venueState } from "./venues/state";
import { bookingPluginsState } from "./plugins/state";
import { artistStates } from "./artists/state";
import { BookingModulePluginStore } from "./plugins";
import { templateState } from "./templates/state"

// import { checklist } from '../models/checklists.model';
// import { defaultBookingOverview } from '../models/booking-overview.model';
// import { defaultInvoiceLines } from '../models/invoice-lines.model';
// import { DataStates } from '../../../store/global/data-state';
// import { createDropdownItem } from '../models/booking-artist.model';
// import { initializeFilter, getSelectMonthDefaultDate } from '../models/filter.model';

// const pathSeparator = '.';
// const cdate = (path) => `cdate${pathSeparator}${path}`;

// const bookingSidewindowTabs = [
//   { route: 'overview', value: 'tab_title_overview', VGI_ID: 'artists' },
//   { route: 'money', value: 'tab_title_new_deals', VGI_ID: 'money_details_section' },
//   { route: 'documents', value: 'tab_title_documents', VGI_ID: 'documents_section' },
//   { route: 'event', value: 'tab_title_artist_details', VGI_ID: 'event_details_section' },
//   { route: 'travels', value: 'tab_title_travel_details', VGI_ID: 'travel_details_section' },
//   { route: 'local', value: 'tab_title_local_details', VGI_ID: 'local_details_section' },
//   { route: 'map', value: 'tab_title_google_map', VGI_ID: 'artists' },
// ];

export const state = {
  /** Booking Module Info states */

  // users: [],
  // artists: [],
  // statuses: [],
  // months: [],
  // contract_months: [],

  // bookingList: [],

  // // External Calendar Dates -- this will be imported from different calendar source
  // externalDates: [],

  // filter: initializeFilter(),

  // selectedMonths: createDropdownItem(getSelectMonthDefaultDate()),
  // bookingListHeaders: [
  //   { value: 'start_date', text: 'Related Bookings', tkey: 'start_date', },
  //   { value: 'artist_name', text: 'Artist', tkey: 'artist', },
  //   { value: 'booking_status_name', text: 'Status', tkey: 'status', },
  //   { value: 'booking_location_name', text: 'Venue', tkey: 'venue', },
  //   { value: 'city', text: 'City', tkey: 'city', },
  //   { value: 'booking_process', text: 'Booking Process', tkey: 'booking_process', },
  // ],
  // bookingDetailsFlag: false,
  // selectedBooking: {},
  // selectedBookingCancellationToken: null,

  // bookingArtistList: [],
  // bookingOverviewArtists: [],
  // eventDetailsArtists: [],

  // bookingOverview: defaultBookingOverview(),

  // bookingSidewindowTabs: bookingSidewindowTabs,
  // bookingSideWindowSelectedTab: bookingSidewindowTabs[0].route,

  // // overview_gridLayout: createGridLayout({
  // //   layout: [
  // //     createGridItem({
  // //       x: 0,
  // //       y: 0,
  // //       w: 60,
  // //       h: 15,
  // //       i: 'artists',
  // //     }),
  // //     createGridItem({
  // //       x: 0,
  // //       y: 15,
  // //       w: 30,
  // //       h: 10,
  // //       i: 'notes_for_rider',
  // //     }),
  // //     createGridItem({
  // //       x: 30,
  // //       y: 25,
  // //       w: 30,
  // //       h: 20,
  // //       i: 'checklist',
  // //     }),
  // //     createGridItem({
  // //       x: 30,
  // //       y: 35,
  // //       w: 30,
  // //       h: 10,
  // //       i: 'custom_checklist',
  // //     }),
  // //     createGridItem({
  // //       x: 0,
  // //       y: 35,
  // //       w: 30,
  // //       h: 10,
  // //       i: 'deal_memo_internal',
  // //     }),
  // //     createGridItem({
  // //       x: 0,
  // //       y: 45,
  // //       w: 30,
  // //       h: 10,
  // //       i: 'tab_title_memos',
  // //     }),
  // //     createGridItem({
  // //       isResizable: false,
  // //       x: 0,
  // //       y: 70,
  // //       w: 60,
  // //       h: 5,
  // //       i: 'money_details_section',
  // //     }),
  // //     createGridItem({
  // //       x: 0,
  // //       y: 80,
  // //       w: 60,
  // //       h: 25,
  // //       i: 'invoicing',
  // //     }),
  // //     createGridItem({
  // //       isResizable: false,
  // //       x: 0,
  // //       y: 130,
  // //       w: 60,
  // //       h: 5,
  // //       i: 'create_invoice_button',
  // //     }),
  // //     createGridItem({
  // //       isResizable: false,
  // //       x: 0,
  // //       y: 135,
  // //       w: 60,
  // //       h: 5,
  // //       i: 'documents_section',
  // //     }),
  // //     createGridItem({
  // //       y: 140,
  // //       w: 30,
  // //       h: 15,
  // //       i: 'Templates'
  // //     }),
  // //     createGridItem({
  // //       y: 140,
  // //       x: 30,
  // //       w: 30,
  // //       h: 15,
  // //       i: 'Document'
  // //     }),
  // //     createGridItem({
  // //       x: 0,
  // //       y: 155,
  // //       w: 30,
  // //       h: 15,
  // //       i: 'Files'
  // //     }),
  // //     createGridItem({
  // //       isResizable: false,
  // //       x: 0,
  // //       y: 170,
  // //       w: 60,
  // //       h: 5,
  // //       i: 'send_document_button',
  // //     }),
  // //     createGridItem({
  // //       isResizable: false,
  // //       y: 175,
  // //       w: 60,
  // //       h: 5,
  // //       i: 'event_details_section',
  // //     }),
  // //     createGridItem({
  // //       y: 180,
  // //       w: 60,
  // //       h: 15,
  // //       i: 'Artists'
  // //     }),
  // //     createGridItem({
  // //       x: 0,
  // //       y: 195,
  // //       w: 30,
  // //       h: 10,
  // //       i: 'Line-Up'
  // //     }),
  // //     createGridItem({
  // //       x: 30,
  // //       y: 195,
  // //       w: 30,
  // //       h: 24,
  // //       i: 'Local Infos'
  // //     }),
  // //     createGridItem({
  // //       x: 0,
  // //       y: 205,
  // //       w: 30,
  // //       h: 8,
  // //       i: 'Event Details'
  // //     }),
  // //     createGridItem({
  // //       x: 0,
  // //       y: 213,
  // //       w: 60,
  // //       h: 5,
  // //       i: 'travel_details_section'
  // //     }),
  // //     createGridItem({
  // //       y: 218,
  // //       w: 60,
  // //       h: 15,
  // //       i: 'Travel Before'
  // //     }),
  // //     createGridItem({
  // //       y: 233,
  // //       w: 60,
  // //       h: 15,
  // //       i: 'Travel After'
  // //     }),
  // //     createGridItem({
  // //       y: 248,
  // //       w: 30,
  // //       h: 10,
  // //       i: 'Contact Relations'
  // //     }),
  // //     createGridItem({
  // //       x: 45,
  // //       y: 248,
  // //       w: 15,
  // //       h: 10,
  // //       i: 'get_contracts_button'
  // //     }),
  // //     createGridItem({
  // //       y: 250,
  // //       w: 60,
  // //       h: 5,
  // //       i: 'local_details_section'
  // //     }),
  // //     createGridItem({
  // //       y: 255,
  // //       w: 60,
  // //       h: 10,
  // //       i: 'relation'
  // //     }),
  // //     createGridItem({
  // //       y: 265,
  // //       w: 40,
  // //       h: 10,
  // //       i: 'Local Infos'
  // //     }),
  // //     createGridItem({
  // //       x: 40,
  // //       y: 255,
  // //       w: 20,
  // //       h: 5,
  // //       i: 'local_details_confirmed_flag'
  // //     }),
  // //   ],
  // // }),
  // artistListHeader: [
  //   {
  //     text: '',
  //     tkey: '',
  //     value: 'artist_name',
  //     sortable: false,
  //     align: 'left',
  //   },
  //   {
  //     text: 'Performance Type',
  //     tkey: '',
  //     value: 'performance_type',
  //     sortable: false,
  //     align: 'left',
  //   },
  //   {
  //     text: 'Status',
  //     tkey: 'status',
  //     value: 'booking_status_name',
  //     align: 'left',
  //   },
  //   {
  //     text: 'Offer Notes',
  //     tkey: 'first_offer',
  //     value: 'first_offer_notes',
  //     align: 'left',
  //   },
  //   { text: '', tkey: '', value: 'mail', align: 'left' },
  //   { text: '', tkey: '', value: 'close', align: 'left' },
  // ],
  // artistStatuses: [
  //   {
  //     text: 'TBC',
  //     value: 'TBC',
  //     color: '#F2CF07',
  //   },
  //   {
  //     text: 'Confirmed',
  //     value: 'Confirmed',
  //     color: 'rgb(68, 199, 81)',
  //   },
  //   {
  //     text: 'confirmed (not public)',
  //     value: 'confirmed (not public)',
  //     color: 'rgb(5, 135, 46)',
  //   },
  //   {
  //     text: 'Day Off',
  //     value: 'Day Off',
  //     color: 'rgb(5, 0, 0',
  //   },
  //   {
  //     text: 'Request',
  //     value: 'Request',
  //     color: 'rgb(58, 39, 230)',
  //   },
  //   {
  //     text: 'cancelled',
  //     value: 'cancelled',
  //     color: 'rgb(255, 0, 0)',
  //   },
  //   {
  //     text: '',
  //     value: 'Default',
  //     color: 'rgb(68, 199, 81)',
  //   },
  // ],
  // custom_checklist: [],
  // checklist: checklist,
  // notes: {
  //   dataState: DataStates.LOADED,
  //   value: '',
  //   xpath: cdate('notes'),
  // },
  // offer_notes: {
  //   dataState: DataStates.LOADED,
  //   value: '',
  //   xpath: cdate('first_offer_notes'),
  // },
  // selectedBookingTasks: [],
  // moneyDetailsGridLayout: {
  //   ...defaultGridLayout,
  //   layout: [
  //     createGridItem({
  //       w: 60,
  //       h: 25,
  //       i: 'Invoicing',
  //     }),
  //   ],
  // },
  // moneyDetailsInvoicesListHeaders: [
  //   {
  //     text: '',
  //     value: 'artist_name',
  //     sortable: false,
  //     align: 'left',
  //   },
  //   {
  //     text: 'Item',
  //     value: 'item_name',
  //     sortable: false,
  //     align: 'left',
  //   },
  //   {
  //     text: 'Text',
  //     value: 'text',
  //     align: 'left',
  //   },
  //   {
  //     text: 'Amount/Currency',
  //     value: 'price, ',
  //     align: 'left',
  //   },
  //   {
  //     text: 'Due',
  //     value: 'due_date',
  //     align: 'left',
  //   },
  //   {
  //     text: 'Invoice',
  //     value: 'invoice_item_id',
  //     align: 'left',
  //   },
  //   {
  //     text: 'Tax Type',
  //     value: 'tax_type_id',
  //     align: 'left',
  //   },
  //   {
  //     text: '',
  //     value: 'close',
  //     align: 'left',
  //   },
  // ],

  // // Selected Invoice Lines are kept in the store state
  // selectedInvoiceLines: new Set(),
  // invoiceLines: defaultInvoiceLines(),
  // taxTypes: [],

  // sendDocumentFilesData: {
  //   calendar_date_id: '',
  //   contact_id_promoter: '',
  //   document_send_title: '',
  //   documents: [],
  //   files: [],
  //   invoices: [],
  // },

  // itemGroups: [],

  // loggedUserTasks: [],
  // bookingRequests: [],
  // bookingRequestSelectedItem: {},
  // bookingTemplates: [],

  // ...documentState,
  // ...travelDetailsState,
  // ...localDetailsState,

  // Artist State
  ...bookingsState,
  ...artistStates,
  ...bookingPromotersState,
  ...bookingReportsStates,
  ...venueState,
  ...BookingModulePluginStore.state,
  ...templateState
};
